// Level-4 Menu Hover Script
document.addEventListener('DOMContentLoaded', function() {

    let allEvents = [];
    // Function to handle level-3 hover behavior
    function initLevel3Hover() {
        // Find all level-3 items that have children
        const level3Items = document.querySelectorAll('.level-3-item.has-child');
        
        level3Items.forEach(function(item) {
            const detailsElement = item.querySelector('details');
            const summaryElement = item.querySelector('summary');
            
            if (detailsElement && summaryElement) {
                let hoverTimeout;
                
                // Mouse enter event
                const handleMouseEnter = () => {
                  clearTimeout(hoverTimeout);
                  // Open the details element
                  detailsElement.setAttribute('open', window.innerWidth);
                }
                const handleMouseLeave = () => {
                  // Add delay before closing to prevent flickering
                  hoverTimeout = setTimeout(function() {
                    // Close the details element
                    detailsElement.removeAttribute('open');
                    // Remove hover class
                  }, 150); // 150ms delay
                }
                item.addEventListener('mouseenter', handleMouseEnter);
                item.addEventListener('mouseleave', handleMouseLeave);
                allEvents.push([item, 'mouseenter', handleMouseEnter])
                allEvents.push([item, 'mouseleave', handleMouseLeave])
                
                // Prevent closing when hovering over the disclosure panel
                const disclosurePanel = item.querySelector('.disclosure__panel');
                if (disclosurePanel) {
                    const handlePanelEnter = () => {
                      clearTimeout(hoverTimeout);
                    }
                    const handlePanelLeave = () => {
                      hoverTimeout = setTimeout(function() {
                        if (window.innerWidth > 768) detailsElement.removeAttribute('open');
                      }, 150);
                    }
                    disclosurePanel.addEventListener('mouseenter', handlePanelEnter);
                    disclosurePanel.addEventListener('mouseleave', handlePanelLeave);
                    allEvents.push([disclosurePanel, 'mouseenter', handleMouseEnter])
                    allEvents.push([disclosurePanel, 'mouseleave', handleMouseLeave])
                }
            }
        });
    }
    
    // Function to handle mega nav specific behavior
    function initMegaNavHover() {
        // For mega navigation, we want to ensure proper hover behavior
        const megaNavItems = document.querySelectorAll('.mega-nav .level-3-item');
        
        megaNavItems.forEach(function(item) {
            const detailsElement = item.querySelector('details');
            
            if (detailsElement) {
                // In mega nav, we might want different behavior
                // For now, we'll use the same hover logic
                let hoverTimeout;
                
                const handleMegaNavEnter = () => {
                  clearTimeout(hoverTimeout);
                  if (window.innerWidth > 768) detailsElement.setAttribute('open', '');
                }
                const handleMegaNavLeave = () => {
                  hoverTimeout = setTimeout(function() {
                    if (window.innerWidth > 768) detailsElement.removeAttribute('open');
                  }, 200); // Slightly longer delay for mega nav
                }
                item.addEventListener('mouseenter', handleMegaNavEnter);
                item.addEventListener('mouseleave', handleMegaNavLeave);
            }
        });
    }
    
    // Function to handle mobile behavior
    function initMobileBehavior() {
        // On mobile, we want to use click instead of hover
            const level3Items = document.querySelectorAll('.level-3-item.has-child');
            
            level3Items.forEach(function(item) {
                const detailsElement = item.querySelector('details');
                const summaryElement = item.querySelector('summary');
                
                if (detailsElement && summaryElement) {
                    // Add click behavior for mobile
                    const handleClick = () => {
                      e.preventDefault();

                      // Toggle the details element
                      if (detailsElement.hasAttribute('open')) {
                        detailsElement.removeAttribute('open');
                      } else {
                        detailsElement.setAttribute('open', '');
                      }
                    }
                    summaryElement.addEventListener('click', handleClick);
                    allEvents.push([summaryElement, 'click', handleClick]);
                }
            });
    }

  const clearAllEvents = () => {
    allEvents.forEach(([element, event, ref]) => {
      element.removeEventListener(event, ref);
    })
    allEvents = [];
  }
    
    // Initialize all hover behaviors
    function init() {
        clearAllEvents()
        if (window.innerWidth > 768) {
            initLevel3Hover();
            initMegaNavHover();
        } else {
            initMobileBehavior()
        }
    }
    
    // Run initialization
    init();
    
    // Handle window resize for mobile/desktop switching
    let resizeTimeout;
    window.addEventListener('resize', function() {
        clearTimeout(resizeTimeout);
        resizeTimeout = setTimeout(function() {
            init(); // Re-initialize on resize
        }, 250);
    });
    
    // Handle dynamic content loading (if any)
    function handleDynamicContent() {
        // If content is loaded dynamically, re-initialize
        const observer = new MutationObserver(function(mutations) {
            mutations.forEach(function(mutation) {
                if (mutation.type === 'childList' && mutation.addedNodes.length > 0) {
                    // Check if new level-3 items were added
                    const hasNewLevel3Items = Array.from(mutation.addedNodes).some(function(node) {
                        return node.nodeType === 1 && (
                            node.classList.contains('level-3-item') ||
                            node.querySelector('.level-3-item')
                        );
                    });
                    
                    if (hasNewLevel3Items) {
                        setTimeout(init, 100); // Re-initialize after a short delay
                    }
                }
            });
        });
        
        // Start observing
        observer.observe(document.body, {
            childList: true,
            subtree: true
        });
    }
    
    // Initialize dynamic content handling
    handleDynamicContent();
});

// Export functions for potential external use
window.Level4MenuHover = {
    init: function() {
        // Re-initialize function that can be called externally
        document.addEventListener('DOMContentLoaded', function() {
            // Re-run initialization
            init();
        });
    }
}; 
